module.exports = __webpack_public_path__ + "static/home_06-afb9df7f792b0e919a408d58ca1ff591.webp";